import * as React from 'react';
import { ApiV1Job } from '@app/Models/WebApiModels';
import { ToolTipItem } from '@app/Components/ToolTipItem';
import { getJobErrorMessage } from '../../Models/JobListModels';
import './job-list-title.scss';

type JobListTitleProps = {
    showExecutions?: boolean;
    executions: string[];
    failedJobs: ApiV1Job[];
};

export default class JobListTitle extends React.PureComponent<JobListTitleProps> {
    public render() {
        const { showExecutions, executions, failedJobs } = this.props;
        return (
            <span className="job-list-title">
                Job List
                <span className="job-top-executions">
                    {!!failedJobs.length && (
                        <div className="job-top-executions-list">
                            <b>Failed:</b>
                            {failedJobs.map((x) => {
                                const elementId = `topFailedJob_${x.name}`;
                                const errorMessage = getJobErrorMessage(x);
                                return (
                                    <div key={elementId}>
                                        <span id={elementId} className="top-job-item badge badge-danger">{x.name}</span>
                                        {!!errorMessage && <ToolTipItem className="tooltip-wide" text={errorMessage} targetId={elementId} />}
                                    </div>
                                );
                            })}
                        </div>
                    )}
                    {showExecutions && (
                        <div className="job-top-executions-list">
                            <b>Executions:</b>
                            {executions.map((x, i) => (
                                <span key={'topExecutions_' + i} className="top-job-item badge badge-info">
                                    {x}
                                </span>
                            ))}
                        </div>
                    )}
                </span>
            </span>
        );
    }
}
